<div class="row">
    <div class="col-sm-12">
    </div>
</div>
<div class="row">
    <div class="epi-container col">
        <h4>
            Carrier Search:
            <input type="radio" id="searchTypeDomiciled" name="searchType" [value]="'domiciled'"
                   [checked]="searchType=='domiciled'" (click)="getSearchType('domiciled')" /> Domiciled
            <input type="radio" id="searchTypeLane" name="searchType" [value]="'lane'"
                   [checked]="searchType=='lane'" (click)="getSearchType('lane')" /> Lane
        </h4>
        <i class="fa" (click)="toggleFlag('search')" [ngClass]="{'fa-plus': divFlags['search'] == false, 'fa-minus': divFlags['search'] == true}" aria-hidden="true"></i>
        <div class="row" *ngIf="divFlags['search']">
            <div class="col" *ngIf="searchType=='domiciled'">
                <h2>Domiciled</h2>
                <div class="row">
                    <div class="col-sm-6">
                        <label class="font-weight-bold" [ngClass]="isFieldInvalid('domiciledCityID') ? 'text-danger' : ''">City</label>
                        <city-state-zip-dropdown [parentForm]="searchCarrierForm"
                                                 [ctrlName]="'domiciledCityStateZipCtrl'"
                                                 [placeholder]="'Enter a City'"
                                                 (citySelected)="citySTChanged($event,'domiciled')"
                                                 [cityID]="searchCarrierCriteria.domiciledCityID"
                                                 [defaultCity]="domiciledCity.cityST"
                                                 [isChooseDefaultZip]="true"
                                                 [isRequired]="searchCarrierCriteria.domiciledRadiusMiles > 0"></city-state-zip-dropdown>
                    </div>
                    <div class="col-sm-6">
                        <label class="font-weight-bold" [ngClass]="isFieldInvalid('domiciledRadiusMiles') ? 'text-danger' : ''">Radius (mi)</label>
                        <input id="searchCarrierCriteria.domiciledRadiusMiles" [(ngModel)]="searchCarrierCriteria.domiciledRadiusMiles" class="form-control" type="number" step="1" [required]="domiciledCity.cityID > 0" />
                    </div>
                </div>
                <!--<div class="row">
        <div class="col-sm-6">
            <label class="font-weight-bold">Employee Assigned</label>
            <select name="searchCarrierCriteria.assignedEmployeeID" [(ngModel)]="searchCarrierCriteria.AssignedEmployeeID" class="form-select">
                <option value="0">- Select Employee -</option>
                <option *ngFor="let employee of carrierRepList" value="{{employee.employeeId}}">{{employee.fullName}}</option>
            </select>
        </div>
    </div>-->
            </div>
            <div class="col" *ngIf="searchType=='lane'">
                <h2>Lane Search</h2>
                <div class="row">
                    <div class="col-sm-6">
                        <label class="font-weight-bold" [ngClass]="isFieldInvalid('originCityID') ? 'text-danger' : ''">Origin</label>
                        <city-state-zip-dropdown [parentForm]="searchCarrierForm"
                                                 [ctrlName]="'originCityStateZipCtrl'"
                                                 [placeholder]="'Enter a City'"
                                                 (citySelected)="citySTChanged($event,'origin')"
                                                 [cityID]="searchCarrierCriteria.originCityID"
                                                 [defaultCity]="originCity.cityST"
                                                 [isChooseDefaultZip]="true"
                                                 [isRequired]="searchCarrierCriteria.originRadiusMiles > 0"></city-state-zip-dropdown>
                    </div>
                    <div class="col-sm-6">
                        <label class="font-weight-bold" [ngClass]="isFieldInvalid('originRadiusMiles') ? 'text-danger' : ''">Origin Radius (mi)</label>
                        <input id="searchCarrierCriteria.originRadiusMiles" [(ngModel)]="searchCarrierCriteria.originRadiusMiles" class="form-control" type="number" step="1" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <label class="font-weight-bold" [ngClass]="isFieldInvalid('destinationCityID') ? 'text-danger' : ''">Destination</label>
                        <city-state-zip-dropdown [parentForm]="searchCarrierForm"
                                                 [ctrlName]="'destinationCityStateZipCtrl'"
                                                 [placeholder]="'Enter a City'"
                                                 (citySelected)="citySTChanged($event,'destination')"
                                                 [cityID]="searchCarrierCriteria.destinationCityID"
                                                 [defaultCity]="destinationCity.cityST"
                                                 [isChooseDefaultZip]="true"
                                                 [isRequired]="searchCarrierCriteria.destinationRadiusMiles > 0"></city-state-zip-dropdown>
                    </div>
                    <div class="col-sm-6">
                        <label class="font-weight-bold" [ngClass]="isFieldInvalid('destinationRadiusMiles') ? 'text-danger' : ''">Destination Radius (mi)</label>
                        <input id="searchCarrierCriteria.destinationRadiusMiles" [(ngModel)]="searchCarrierCriteria.destinationRadiusMiles" class="form-control" type="number" step="1" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <label class="font-weight-bold" [ngClass]="isFieldInvalid('modeID') ? 'text-danger' : ''">Mode</label>
                        <select name="searchCarrierCriteria.modeID" [(ngModel)]="searchCarrierCriteria.modeID" class="form-select" required>
                            <option value="0">- Select Mode -</option>
                            <option *ngFor="let mode of modeList" value="{{mode.modeID}}">{{mode.abbrev}} - {{mode.description}}</option>
                        </select>
                    </div>
                    <div class="col-sm-6">
                        <label class="font-weight-bold" [ngClass]="isFieldInvalid('trailerTypeID') ? 'text-danger' : ''">Trailer</label>
                        <select name="searchCarrierCriteria.trailerTypeID" [(ngModel)]="searchCarrierCriteria.trailerTypeID" class="form-select" required>
                            <option value="0">- Select Trailer -</option>
                            <option *ngFor="let trailerType of trailerTypeList" value="{{trailerType.trailerTypeID}}">{{trailerType.abbrev}} - {{trailerType.description}}</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <input type="checkbox" [(ngModel)]="searchCarrierCriteria.isRoundTrip" style="cursor: pointer;margin: 10px; transform: scale(1.5);" /> Round Trip
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-sm-12">
                        <h2>Equipment</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <select name="searchCarrierCriteria.equipmentClassID" [(ngModel)]="searchCarrierCriteria.equipmentClassID" class="form-select" (change)="equipmentClassChange($event)">
                            <option value="0">Select Class</option>
                            <option *ngFor="let item of equipmentClassList" value="{{item.equipmentClassID}}">[{{item.abbreviation}}] {{item.className}}</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div style="margin:5px;height:200px;overflow:scroll;border:1px solid #ccc;">
                            <table>
                                <tr *ngFor="let item of filteredTrailerEquipmentClassList">
                                    <td><input type="checkbox" [(ngModel)]="item.isChecked" [checked]="item.isChecked" style="margin:5px;transform: scale(1.5);" /></td>
                                    <td (click)="item.isChecked=!item.isChecked">{{item.trailerTypeAbbrev}}</td>
                                    <td (click)="item.isChecked=!item.isChecked">{{item.trailerTypeDescription}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <h2>Services</h2>
                <div class="row">
                    <div class="col-sm-12">
                        <div style="margin:5px;height:200px;overflow:scroll;border:1px solid #ccc;">
                            <table>
                                <tr *ngFor="let item of carrierServiceList">
                                    <td><input type="checkbox" [(ngModel)]="item.isChecked" [checked]="item.isChecked" style="margin:5px;transform: scale(1.5);" /></td>
                                    <td (click)="item.isChecked=!item.isChecked">{{item.abbreviation}}</td>
                                    <td (click)="item.isChecked=!item.isChecked">{{item.description}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6" *ngIf="divFlags['search']">
                <button (click)="getSearchCarrierList()" class="btn btn-sml btn-primary" title="Search" [disabled]="isSearchInvalid()">Search</button>
                <button (click)="clearSearchCarrierList()" class="btn btn-sml btn-secondary m-2" title="Search">Clear</button>
                <span class="text-danger font-weight-bold" *ngIf="isSearchInvalid()">
                    * All fields in red required to "Search"
                </span>
            </div>
            <div class="col k-text-end">
                <h2 class="text-primary">Results: {{filteredSearchCarrierList.length}} Carriers</h2>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col">
        <kendo-grid #carrierSearchGrid
                    [data]="searchGridData"
                    [pageSize]="searchGridState.take"
                    [skip]="searchGridState.skip"
                    [sort]="searchGridState.sort"
                    [filter]="searchGridState.filter"
                    [sortable]="true"
                    [pageable]="true"
                    [filterable]="true"
                    [resizable]="true"
                    (dataStateChange)="searchDataStateChange($event)">
            <kendo-grid-command-column title="Action">
                <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem>
                    <button type="button" class="btn btn-sml btn-success m-1" title="Edit" tabindex="-1" (click)="edit(dataItem)"><i class="fas fa-pencil-alt"></i></button>
                </ng-template>
            </kendo-grid-command-column>
            <kendo-grid-column field="carrierCode" title="Carrier">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <rmis-status [rmisStatusColor]="dataItem.rmisStatusColor" [rmisStatusTextColor]="dataItem.rmisStatusTextColor" [rmisStatusAbbrev]="dataItem.rmisStatusAbbrev" [rmisStatusTooltip]="dataItem.nonCertifiedReasons"></rmis-status>
                    <a target="_blank" [routerLink]="['/carrier-detail', dataItem.carrierCode]">
                        {{dataItem.carrierName}}
                    </a>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="carrierCode" title="Carrier 3x3">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <a target="_blank" [routerLink]="['/carrier-detail', dataItem.carrierCode]">
                        {{dataItem.carrierCode}}
                    </a>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="mcNumber" title="MC Number"></kendo-grid-column>
            <kendo-grid-column field="carrierCity" title="City"></kendo-grid-column>
            <kendo-grid-column field="carrierState" title="ST"></kendo-grid-column>
            <kendo-grid-column field="carrierZip" title="Zip"></kendo-grid-column>
            <kendo-grid-column field="domiciledMarket" title="Market"></kendo-grid-column>
            <kendo-grid-column field="truckCount" title="Trucks"></kendo-grid-column>
            <kendo-grid-column field="trailerCount" title="Trailers"></kendo-grid-column>
            <kendo-grid-column field="procurementCount" title="Procurements"></kendo-grid-column>
            <kendo-grid-column field="carrierTeam" title="Team"></kendo-grid-column>
            <kendo-grid-column field="totalHardContacts" title="Hard Contacts"></kendo-grid-column>
            <kendo-grid-column field="lastProcurementDate" title="Last Procurement">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span *ngIf="dataItem.lastProcurementDate != null">
                        {{dataItem.lastProcurementDate | date: 'M/dd/yy'}}
                    </span>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>
</div>

<div class="spinner_container dark-overlay" [ngClass]="{'dark-overlay':isLoading}" *ngIf="isLoading">
    <mat-spinner style="left: 50%; top: 50%" *ngIf="isLoading"></mat-spinner>
</div>
